import { registerBlockType } from '@wordpress/blocks';
import './style.scss';
import './editor.scss';
import Edit from './edit';
import save from './save';
import metadata from './block.json';
import indexjson from './edit.json';
import advancejson from '@vayu-blocks/advance-panel/advance.json';

const faqsvg = (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="#6c1bc3" context="list-view" aria-hidden="true" focusable="false">
		<path d="M9.00006 9C9.50006 8 10.5001 7 12.0001 7C13.5002 7 15.0001 8.5 15.0001 10C15.0001 11.4553 14.0588 12.4399 13.0843 12.8686C13.0248 12.8948 12.9619 12.9116 12.8992 12.9285C12.4001 13.0627 12.0001 13.4804 12.0001 14M12.0001 17H12.0101M21.0001 12C21.0001 16.9706 16.9706 21 12.0001 21C10.5124 21 9.1091 20.6391 7.87286 20C7.19356 19.6488 3.56466 21.5054 3 21C2.43678 20.4959 4.93748 17.6302 4.51561 17C3.55833 15.5699 3.00006 13.8501 3.00006 12C3.00006 7.02944 7.0295 3 12.0001 3C16.9706 3 21.0001 7.02944 21.0001 12Z" fill="none" stroke="#6c1bc3" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round">
		</path>
	</svg>
);

registerBlockType( metadata.name, {
	...metadata,
	attributes: {...indexjson, ...advancejson},
	edit: Edit,
	icon: faqsvg,
	save,
});